import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  get window(): Window {
    return window;
  }
  get href(): string {
    return window.location.href;
  }
  set href(url: string) {
    window.location.href = url;
  }

  handle401(url: string) {
    this.href = url;
  }
}
